// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__t8lki","navLink":"style_navLink__2W46y","headerFixed":"style_headerFixed__9C4sk","headerIcon":"style_headerIcon__11vpD","icon":"style_icon__3l_S5"};